const temporaryActionTypes = {
    setLoggedOutMessage: 'SET_LOGGED_OUT_MESSAGE'
};

export default temporaryActionTypes;